export default "__VITE_ASSET__BgU3DIth__"